import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Linkedin, Send } from 'lucide-react';
import { usePageTitle } from '../contexts/PageTitleContext';

export default function Contact() {
  usePageTitle().setTitle('Contatti - Sea Level Traders');
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0c1929 0%, #0f2942 50%, #0c1929 100%)' }}>
      {/* Hero */}
      <section className="relative py-20 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 text-sm font-medium"
               style={{ background: 'rgba(6,182,212,0.15)', color: '#22d3ee', border: '1px solid rgba(6,182,212,0.3)' }}>
            <Send size={16} />
            Contatti
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ lineHeight: '1.15' }}>
            Parliamo del tuo
            <span className="block" style={{ color: '#22d3ee' }}>Business Nautico</span>
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Sei un dealer, broker o cantiere interessato a vendere su Sea Level Traders? Compila il form o contattaci direttamente.
          </p>
        </div>
      </section>

      {/* Contatti + Form */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8">
          {/* Info */}
          <div className="rounded-2xl p-8" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h2 className="text-2xl font-bold text-white mb-6">Informazioni di Contatto</h2>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <Phone className="mt-1" size={20} style={{ color: '#22d3ee' }} />
                <div>
                  <div className="text-white font-semibold">Telefono</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)' }}>+39 377 387 1722</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail className="mt-1" size={20} style={{ color: '#22d3ee' }} />
                <div>
                  <div className="text-white font-semibold">Email</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)' }}>info@sealevel.it</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="mt-1" size={20} style={{ color: '#22d3ee' }} />
                <div>
                  <div className="text-white font-semibold">Sede</div>
                  <div style={{ color: 'rgba(255,255,255,0.7)' }}>Bari, Italia</div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Linkedin className="mt-1" size={20} style={{ color: '#22d3ee' }} />
                <div>
                  <div className="text-white font-semibold">LinkedIn</div>
                  <a href="https://www.linkedin.com/company/sealeveltraders" target="_blank" rel="noopener noreferrer"
                     className="text-sm underline" style={{ color: '#22d3ee' }}>
                    Sea Level Traders
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Form placeholder */}
          <div className="rounded-2xl p-8" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <h2 className="text-2xl font-bold text-white mb-6">Invia una Richiesta</h2>
            <form className="space-y-4" onSubmit={(e) => { e.preventDefault(); alert('Form di contatto in arrivo.'); }}>
              <div>
                <label className="block text-sm font-medium text-white mb-1">Nome e cognome</label>
                <input type="text" required className="w-full rounded-lg px-4 py-2 text-white"
                       style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
                       placeholder="Mario Rossi" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-1">Azienda</label>
                <input type="text" required className="w-full rounded-lg px-4 py-2 text-white"
                       style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
                       placeholder="Nautica Rossi Srl" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-1">Email</label>
                <input type="email" required className="w-full rounded-lg px-4 py-2 text-white"
                       style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
                       placeholder="mario@nauticarossi.it" />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-1">Messaggio</label>
                <textarea rows={4} required className="w-full rounded-lg px-4 py-2 text-white"
                          style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}
                          placeholder="Sono interessato a vendere le mie barche su Sea Level Traders..." />
              </div>
              <button type="submit" className="w-full px-8 py-3 rounded-xl font-semibold text-white transition-all"
                      style={{ background: 'linear-gradient(135deg, #06b6d4, #0891b2)', boxShadow: '0 4px 20px rgba(6,182,212,0.3)' }}>
                Invia Richiesta
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}
